import React from "react";
import * as XLSX from 'xlsx';
import { Form, Input, Label, FormGroup, Col } from "reactstrap";
import styled from "styled-components";
import { addNotification } from "notificationStore";
import i18next from "i18next";

const BarcodeFileUploadForm = ({
  className,
  fileHeaders,
  setFileHeaders,
  formData,
  setFormData,
  shouldMapDeliveryMonths
}) => {

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        ["file"]: file,
      });
  
      const fileExtension = file.name.split('.').pop().toLowerCase();
  
      if (fileExtension === 'csv') {
        // Handle CSV files
        const reader = new FileReader();
        reader.onload = (event) => {
          const text = event.target.result;
          const headers = text.split('\n')[0].split(',');
          setFileHeaders(headers);
        };
        reader.readAsText(file);
      } else if (fileExtension === 'xlsx' || fileExtension === 'xls') {
        // Handle Excel files
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          const headers = jsonData[0];
          setFileHeaders(headers);
        };
        reader.readAsArrayBuffer(file);
      } else {
        setFormData({
          ...formData,
          barcode: '',
          quantity: '',
          delivery_month: ''
        });
        // Unsupported file type
        addNotification({ type: "danger", message: i18next.t("barcode.invalidFileFormat") });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  return (
    <div className={`${className} mt-4 my-auto`}>
      <Form className="my-auto" style={{ width: '600px' }}>
        <FormGroup row>
          <Label for="file-upload" sm={3}>Select File to Import :</Label>
          <Col sm={9}>
            <Input
              type="file"
              name="file-upload"
              onChange={handleFileUpload}
              required
            />
          </Col>
        </FormGroup>

        <hr />

        <FormGroup row>
          <Label for="barcode" sm={4}>Map Barcode with :</Label>
          <Col sm={8}>
            <Input
              type="select"
              name="barcode"
              value={formData.barcode}
              onChange={handleChange}
              required
            >
              <option value="">-- Select --</option>
              {fileHeaders.map((header, index) => (
                <option key={index} value={header}>{header}</option>
              ))}
            </Input>
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="quantity" sm={4}>Map Quantity with :</Label>
          <Col sm={8}>
            <Input
              type="select"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              required
            >
              <option value="">-- Select --</option>
              {fileHeaders.map((header, index) => (
                <option key={index} value={header}>{header}</option>
              ))}
            </Input>
          </Col>
        </FormGroup>

        { shouldMapDeliveryMonths &&
          <FormGroup row>
            <Label for="delivery_month" sm={4}>Map Delivery Month with :</Label>
            <Col sm={8}>
              <Input
                type="select"
                name="delivery_month"
                value={formData.delivery_month}
                onChange={handleChange}
                required
              >
                <option value="">-- Select --</option>
                {fileHeaders.map((header, index) => (
                  <option key={index} value={header}>{header}</option>
                ))}
              </Input>
            </Col>
          </FormGroup>
        }
      </Form>
    </div>
  );
};

const StyledBarcodeFileUploadForm = styled(BarcodeFileUploadForm)`
  Label {
    text-align: left;
  }
`;

export default React.memo(StyledBarcodeFileUploadForm);
